import './user.scss';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { ListGroup, Accordion, Card, Row, Col, Container, Button, Image, ListGroupItem} from "react-bootstrap";
import PropTypes from "prop-types";
import defaultPhoto from "../../images/default.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faEllipsisH, faPlus, faChevronLeft, faMapMarkerAlt, faDirections, faLock} from "@fortawesome/free-solid-svg-icons";
import { withRouter, NavLink, Link } from "react-router-dom";
import ApiV2 from "../apiV2"

function User(props) {
    const [followingCount, setFollowingCount] = useState(null);
    const [followerCount, setFollowerCount] = useState(null);
    const [spotMetrics, setSpotMetrics] = useState(null);

    useEffect(() => {
        const fetchFollowingCount = async () => {
        try {
            const response = await ApiV2.getFollowingCount(props.user.userId);
            setFollowingCount(response.Count)
            
        } catch (error) {
            console.log("Unable to fetch following count. Error: ", JSON.stringify(error));
        }
    }
    fetchFollowingCount();
    }
        , []
    );

    useEffect(() => {
        const fetchFollowerCount = async () => {
        try {
            const response = await ApiV2.getFollowCount(props.user.userId);
            setFollowerCount(response.Count)
            
        } catch (error) {
            console.log("Unable to fetch follower count. Error: ", JSON.stringify(error));
        }
    }
    fetchFollowerCount();
    }
        , []
    );

    useEffect(() => {
        const fetchSpotMetrics = async () => {
        try {
            const response = await ApiV2.fetchSpotMetrics(props.user.userId);
            setSpotMetrics(response.data);
        } catch (error) {
            console.log("Unable to fetch metrics. Error: ", JSON.stringify(error));
        }
    }
    fetchSpotMetrics();
    }
        , []
    );


    const getProfilePhoto = (user) =>  {
        if (user.photoURL) {
            return (user.photoURL);
        } else {
            return (defaultPhoto);
        }
    }
    
    return(
        <>
            <ListGroup.Item>
                <Container className="p-0">
                    <Row className="text-center">
                        <Col xs={2} onClick={() => props.history.push(`/user/${props.user.userId}`)}>
                            <Image className="profile-photo" src={getProfilePhoto(props.user)} roundedCircle />
                        </Col>
                    <Col xs={10} className="p-0" onClick={() => props.history.push(`/user/${props.user.userId}`)}>
                        <Row className="justify-content-center">
                            <span className="font-weight-bold friend-name">
                                {props.user.isPublic ? <></> : <FontAwesomeIcon className="mr-1 text-muted" icon={faLock} />}
                                {props.user.firstName.charAt(0).toUpperCase() + props.user.firstName.slice(1) + " " + props.user.lastName.charAt(0).toUpperCase() + props.user.lastName.slice(1)}
                            </span>
                        </Row>
                        <Row className="justify-content-center friend-info">
                            <span className="font-weight-bold">{followerCount}</span>&nbsp;Followers |&nbsp;<span className="font-weight-bold">{followingCount}</span>&nbsp;Following</Row>
                        <Row className="justify-content-center friend-info">
                            <span className="font-weight-bold">{spotMetrics?.citiesCount}</span>&nbsp;Cities |&nbsp;<span className="font-weight-bold">{spotMetrics?.spotCount}</span>&nbsp;Places |&nbsp;<span className="font-weight-bold">{spotMetrics?.collectionCount}</span>&nbsp;Collections</Row>
                    </Col>
                    </Row>
                </Container>
            </ListGroup.Item>
        </>
    )
}

User.propTypes = {
  user: PropTypes.object.isRequired
};

export default withRouter(User);
